import 'stylesheets/pages/users/index/users_index';
import 'stylesheets/pages/plans/show/_users_plans_detail_wanted_scout_confirm_modal.scss';
import 'stylesheets/pages/scoutees/index/scoutees_form.scss';
import LikeButton from 'modules/LikeButtonSimple';
import UserProfile from 'modules/UserProfile';
import WantedScoutButton from 'modules/WantedScoutButton';

new LikeButton();

new UserProfile();

const wantedScoutTarget = Array.from(document.querySelectorAll('.vue-wanted-scout'));
new WantedScoutButton(wantedScoutTarget);
